import { useEffect } from "react";

export const usePageMeta = (title: string, description: string, keywords?: string) => {
  useEffect(() => {
    document.title = title;
    const descriptionTag = document.querySelector('meta[name="description"]');
    if (descriptionTag) {
      descriptionTag.setAttribute("content", description);
    }
    if (keywords) {
      const keywordsTag = document.querySelector('meta[name="keywords"]');
      if (keywordsTag) {
        keywordsTag.setAttribute("content", keywords);
      }
    }
  }, [title, description, keywords]);
};

export default usePageMeta;